import { _ as _createClass, a as _classCallCheck } from '../../createClass-DV1OmW3s.js';
import isDev from '../../isDev/index.js';

/* eslint-disable no-console */
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  return _createClass(Logger, null, [{
    key: "info",
    value: function info(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var style = arguments.length > 2 ? arguments[2] : undefined;
      isDev && withConsole && console.info(message, style);
    }
  }, {
    key: "success",
    value: function success(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      isDev && withConsole && console.log("%c ".concat(message), 'color:green');
    }
  }, {
    key: "error",
    value: function error(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      isDev && withConsole && console.trace(message);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      isDev && withConsole && console.warn(message);
    }
  }, {
    key: "deprecate",
    value: function deprecate(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      isDev && withConsole && console.warn('DEPRECATION::: ', message);
    }
  }]);
}();

export { Logger as default };
//# sourceMappingURL=index.js.map
